import type { AppManifest, RouterData } from '@wix/editor-platform-sdk-types'
import typeManifest from './typeManifest'
import pagesManifest from './pagesManifest'
import routersManifest from './routersManifest'
import controllersStageDataManifest from './controllersStageDataManifest'
import type { EditorSDK, I18n } from '@wix/wix-data-client-common-standalone'
import type { CollectionsApi } from '@wix/wix-code-collections-api'
import type { Features, EDITOR_TYPE } from '@wix/wix-data-client-common'
import type Experiments from '@wix/wix-experiments'
import type { DataBindingComponentModel } from '@wix/data-binding-registry-sdk'

const getAppManifest = async ({
  hostname,
  t,
  experimentsManager,
  editorSdkProxy,
  editorType,
  bindingDefinitions,
  collectionsApi,
  routers,
  features,
}: {
  hostname: string
  t: I18n['t']
  experimentsManager: Experiments
  editorSdkProxy: EditorSDK
  editorType: EDITOR_TYPE
  bindingDefinitions: Record<string, DataBindingComponentModel>
  collectionsApi: CollectionsApi
  routers: RouterData[] | undefined
  features: Features
}): Promise<AppManifest> => ({
  exports: typeManifest() as AppManifest['exports'],
  routers: features.pagesManifest
    ? ((await routersManifest(
        hostname,
        t,
        experimentsManager,
        editorSdkProxy,
      )) as AppManifest['routers'])
    : undefined,
  pages: features.pagesManifest
    ? ((await pagesManifest({
        hostname,
        t,
        collectionsApi,
        routers,
        editorSdkProxy,
        editorType,
        experimentsManager,
      })) as AppManifest['pages'])
    : undefined,
  controllersStageData: (await controllersStageDataManifest(
    t,
    experimentsManager,
    editorSdkProxy,
    bindingDefinitions,
    features,
  )) as AppManifest['controllersStageData'],
})

export default getAppManifest
